<template>
  <layout
    @backButtonClicked="openModalDiscard"
    :route="backButtonRoute"
    titlePage="Customização do tema"
    class="c-theme-customization"
  >
    <div class="columns is-gapless">
      <div class="column is-narrow">
        <Sidebar v-if="defaultCustomizations" />
      </div>
      <div class="column">
        <SitePreview />
      </div>
    </div>
    <base-modal-bottom ref="discard" title="Descartar alterações">
      <template #btn-close-icon>
        <base-icon
          style="margin: 0 auto"
          width="16"
          height="16"
          name="painel/close-icon"
        />
      </template>

      <div class="has-text-centered">
        <h6 class="is-size-4 has-text-weight-bold">
          Deseja salvar as alterações feitas?
        </h6>
        <p style="margin: 30px 0">
          Você realizou algumas alterações que não foram salvas.
        </p>
        <button
          @click="save"
          style="width: 300px; margin-bottom: 6px"
          type="button"
          class="button is-primary"
        >
          Salvar alterações
        </button>
        <br />
        <button
          @click="closeModalDiscard"
          style="width: 300px; margin-bottom: 6px"
          type="button"
          class="button is-outlined is-black"
        >
          Continuar edição
        </button>
        <br />
        <button
          @click="redirect"
          style="width: 300px; margin-bottom: 6px"
          type="button"
          class="button is-outlined is-black"
        >
          Sim, descartar
        </button>
      </div>
    </base-modal-bottom>
    <base-modal
      v-if="defaultCustomizations === null"
      @modalState="redirect"
      :required="true"
    >
      <template v-slot:content>
        <div class="c-without-customizations">
          <h6 class="c-without-customizations__title">
            Tema sem customizações
          </h6>
          <p class="c-without-customizations__description">
            Seu tema atual não possui customizações disponíveis.
          </p>
          <button @click="redirect" class="button is-primary">
            Voltar para o site
          </button>
        </div>
      </template>
    </base-modal>
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'
import Sidebar from '@/components/ThemeCustomization/Sidebar.vue'
import SitePreview from '@/components/ThemeCustomization/SitePreview.vue'

import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    layout,
    Sidebar,
    SitePreview,
    BaseModalBottom: () => import('@/components/BaseModalBottom.vue'),
    BaseModal: () => import('@/components/BaseModal.vue'),
  },

  computed: {
    ...mapGetters({
      wedSiteUrl: 'app/wedSiteUrl',
      wedSiteThemeId: 'app/getWedSiteThemeId',
      hasChanges: 'theme/hasChangesCustomizations',
      defaultCustomizations: 'theme/defaultCustomizations',
    }),

    backButtonRoute() {
      if (this.hasChanges) return { passive: true }
      return { external: this.wedSiteUrl }
    },
  },

  async mounted() {
    await this.fetchWedSiteInfo()
    await this.fetchTheme(this.wedSiteThemeId)
    this.fetchInitialCustomizations()
  },

  methods: {
    ...mapActions({
      fetchTheme: 'theme/fetchTheme',
      fetchWedSiteInfo: 'app/fetchWedSiteInfo',
      saveCustomizations: 'theme/saveCustomizations',
      fetchInitialCustomizations: 'theme/fetchInitialCustomizations',
      discardCustomizationsWithoutSaving:
        'theme/discardCustomizationsWithoutSaving',
    }),

    async save() {
      if (this.hasChanges) await this.saveCustomizations()
      this.redirect()
    },

    redirect() {
      this.discardCustomizationsWithoutSaving()
      location.href = this.wedSiteUrl
    },

    openModalDiscard() {
      this.$refs.discard.open()
    },

    closeModalDiscard() {
      this.$refs.discard.close()
    },
  },
}
</script>

<style lang="scss">
.c-theme-customization {
  height: 100vh;
  overflow: hidden;

  .c-without-customizations {
    padding: 40px 32px 30px;
    text-align: center;
    color: $gray-6;
    &__title {
      margin-top: 0;
      font-size: 16px;
      font-weight: bold;
      @media (min-width: 400px) {
        font-size: 20px;
      }
    }

    &__description {
      margin: 0 0 48px;
      font-size: 14px;
      font-weight: 400;
      @media (min-width: 400px) {
        font-size: 16px;
      }
    }
  }
}
</style>
